import RssList from './RssList'

export default RssList
